import React, { useState, useEffect } from 'react';
import './EasyInput.css';

interface EasyInputProps {
  label: string;
  type: 0 | 1 | 2 | 3 | 4 | 5; // 0: 字符串, 1: 整数, 2: 小数, 3: 百分数, 4: 密码, 5: 手机号
  onChange: (value: string) => void;
  value: string;
  disabled?: boolean; // 是否禁用
  width?: string; // 宽度，默认100%
  height?: string; // 高度，默认35px
}

const EasyInput: React.FC<EasyInputProps> = ({
  label,
  type,
  onChange,
  value,
  disabled = false, // 默认值为 false
  width = '100%', // 默认宽度100%
  height = '35px', // 默认高度35px
}) => {
  const [inputValue, setInputValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);
  const [labelActive, setLabelActive] = useState(false);

  useEffect(() => {
    setInputValue(value);
    if (value || disabled) {
      setLabelActive(true);
    } else {
      setLabelActive(false);
    }
  }, [value, disabled]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;

    let val = e.target.value;

    if (type === 1) {
      val = val.replace(/[^0-9]/g, '');  // 整数
    } else if (type === 2) {
      val = val.replace(/[^0-9.]/g, ''); // 小数
    } else if (type === 3) {
      val = val.replace(/[^0-9.]/g, ''); // 百分数
    } else if (type === 5) {
      val = val.replace(/[^0-9]/g, '');  // 手机号
    }

    setInputValue(val);
    onChange(val); // 实时回传
  };

  const handleFocus = () => {
    if (!disabled) {
      setIsFocused(true);
      setLabelActive(true);
    }
  };

  const handleBlur = () => {
    if (!disabled) {
      setIsFocused(false);
      if (inputValue === '') {
        setLabelActive(false);
      }
    }
  };

  const handleLabelClick = () => {
    if (!disabled) {
      const inputElement = document.getElementById(`${label}-input`) as HTMLInputElement;
      if (inputElement) {
        inputElement.focus();
      }
    }
  };

  return (
    <div
      className={`easy-input-container ${isFocused ? 'focused' : ''} ${disabled ? 'disabled' : ''}`}
      style={{ width, height, borderColor: '#838383' }}
    >
      <label
        className={`easy-input-label ${labelActive ? 'active' : ''}`}
        style={{
          color: '#3a3939',
          backgroundColor: 'white',
        }}
        onClick={handleLabelClick} // 点击 label 聚焦 input
      >
        {label}
      </label>
      <div className="input-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
        {type === 5 && <span className="phone-prefix">+86</span>}
        <input
          id={`${label}-input`} // 为 input 设置唯一 id
          className="easy-input"
          autoComplete="off"
          type={
            type === 1 || type === 2 || type === 3 || type === 5 ? 'text' :
            type === 4 ? 'password' : 'text'
          }
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={!labelActive ? label : ''}
          style={{ color: disabled ? '#ddd' : '#3a3939' }}
          disabled={disabled}
          readOnly={disabled}
        />
      </div>
    </div>
  );
};

export default EasyInput;